import React from 'react';
import PropTypes from 'prop-types';
import FinancialProductDetailsComponent from './FinancialProductDetailsComponent';
import { useTranslation } from 'react-i18next';
import ViewList from '@mui/icons-material/ViewList';
import { Card } from '@totalsoft/rocket-ui';

const FinancialProductDetailsCard = ({ canWrite, data, productId, isSaved, generalDataLens }) => {
  const [t] = useTranslation();

  return (
    <Card icon={ViewList} iconColor='primary' title={t('FinancialProduct.Details.Header')}>
      <FinancialProductDetailsComponent canWrite={canWrite} data={data} productId={productId} isSaved={isSaved} generalDataLens={generalDataLens} />
    </Card>
  );
};

FinancialProductDetailsCard.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  data: PropTypes.object,
  productId: PropTypes.number.isRequired,
  isSaved: PropTypes.bool.isRequired,
  generalDataLens: PropTypes.object.isRequired
};

export default FinancialProductDetailsCard;
